export default __webpack_public_path__ + "static/media/shopifyExtension6.fee08788.svg";